import { createCrudPage } from './factories/crud-page.js';
import { escapeHtml } from '../core/dom/escape-html.js';

export default createCrudPage({
  title: 'Company Types',
  basePath: '/company-type',
  rowKey: 'pid',
  columns: [
    { key: 'companytype', label: 'Sector type', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Trade' : 'Services' },
    { key: 'companytype_id', label: 'ID', sortable: true },
    { key: 'companytype_name', label: 'Name', sortable: true },
    { key: 'companytype_magazin', label: 'Magazine', sortable: true },
    { key: 'fa_class', label: 'Icon', sortable: true,
      render: (v) => v ? `<i class="${escapeHtml(String(v))}"></i>` : '',
      renderHtml: true },
    { key: 'magazine_color', label: 'Color', sortable: true },
  ],
  fields: [
    { key: 'pid', label: 'ID', type: 'hidden' },
    { key: 'companytype', label: 'Sector type', type: 'select', required: true,
      options: [
        { label: 'Trade', value: '1' },
        { label: 'Services', value: '2' },
      ] },
    { key: 'companytype_id', label: 'Type ID', type: 'text' },
    { key: 'companytype_name', label: 'Name', type: 'text', required: true },
    { key: 'category_title', label: 'Category title', type: 'text' },
    { key: 'category_intro', label: 'Category intro', type: 'text' },
    { key: 'category_description', label: 'Category description', type: 'rich-text' },
    { key: 'companytype_magazin', label: 'Magazine value', type: 'number', defaultValue: 1000 },
    { key: 'fa_class', label: 'Fa icon', type: 'text' },
    { key: 'magazine_color', label: 'Magazine color', type: 'text' },
  ],
  rowActions: [{ key: 'edit', label: 'Edit' }],
  defaultSort: { field: 'companytype', dir: 'desc' },
});
